<template>

  <PrimeDataTable
    :title="'Vacation Type'"
    :showFilter="true"
    :searchOption="true"
    :selectAll="true"
    :showDownload="true"
    :showUpload="false"
    :showAdd="true"
    :columnData="columns"
    :data="data"
    @addDiolog="addDiolog()"
    @rowAction="rowActions($event)"
    activity="VACATIONTYPE"
  />
  <v-dialog persistent v-model="dialog" width="600px">
    <AddVacationType
      ref="AddEnum"
      @reload="getEnumData()"
      @closeDialog="setFalse()"
      :id="enumId"
      :viewType="viewType"
    />
  </v-dialog>
</template>

<script>

import PrimeDataTable from "@/components/PrimeDataTable";
import AddVacationType from "./AddVacationType.vue";
import commonService from "@/common.service";
import VacationTypeService from "@/api/service/VacationType/VacationTypeService";

export default {
  components: {
    // AutoComplete,
    PrimeDataTable,
    AddVacationType,
  },
  props: ["domain"],
  data() {
    return {
      data: [],
      columns: [],
      enumData: [],
      date: new Date(),
      enumId: "",
      dialog: false,
      viewType: false,
    };
  },
  created() {
    this.loadColumns();
    this.download = true;
    this.search = true;
    this.checkbox = true;
    this.getEnumData();
  },
  methods: {
    loadColumns() {
      this.columns = [
        {
          field: "code",
          header: "Code",
          style: { width: "100px", color: "" },
          toolTip: "Code",
          sortfield: true,
        },
        {
          field: "name",
          header: "Name",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        },

        {
          field: "modified",
          header: "Modified",
          style: { width: "100px", color: "" },
          toolTip: "Modified",
          sortfield: true,
        },
        {
          field: "status",
          header: "Status",
          style: { width: "100px", color: "" },
          toolTip: "Status",
          sortfield: true,
        },
        {
          field: "action",
          header: "Action",
          style: { width: "100px", color: "" },
          toolTip: "Action",
          sortfield: true,
          rowActions: [
            { action: "view" },
            { action: "edit" },
          ],
        },
      ];
    },

    setFalse() {
      this.dialog = false;
    },

    rowActions($event) {
      if ($event.type == "view") {
        this.dialog = true;
        this.enumId = $event.data.id;
        this.viewType = $event.type;
      }
      if ($event.type == "edit") {
        this.dialog = true;
        this.enumId = $event.data.id;
        this.viewType = $event.type;
      }

      if ($event.type == "select") {
        this.dialog = true;
        this.enumId = $event.data.id;
        this.viewType = "view";
      }
    },

    async getEnumData() {
      let res = await VacationTypeService.findAll();
      this.data = res;
      console.log(this.data, "dataaaaaaaaa");
    },
    // async  getEnumData(){
    //   let res =await VacationTypeService.findAll({'domain':this.domain.enum})
    //   this.enumData=res
    //   console.log(this.enumData,'lllll')
    addDiolog() {
      this.dialog = true;
      this.enumId = null;
      this.viewType = false;
    },
  },

  addFilter() {
    this.$refs.FilterDrawer.dialog = true;
    this.$refs.FilterDrawer.size = commonService.largeDialog();
  },
};
</script>

<style>
</style>